import { render, staticRenderFns } from "./servicePerformance.vue?vue&type=template&id=660bc567&"
import script from "./servicePerformance.vue?vue&type=script&lang=js&"
export * from "./servicePerformance.vue?vue&type=script&lang=js&"
import style0 from "./servicePerformance.vue?vue&type=style&index=0&id=660bc567&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports